<template>
  <div class="row">
    <div class="col-9">
      <div class="input-group ms-2 mb-3 mt-2">
        <label class="input-group-text" for="vehicleMake">Make:</label>
        <select v-model="vehicleMake" id="vehicleMake" class="form-control custom-select-vehicle" @change="selectedMake">
          <option v-for="item of vehicleMakes" :key="item.id" :value="item.value">
            {{ item.name }}
          </option>
        </select>
        <label class="input-group-text" for="calibration">Calibration:</label>
        <select v-model="calibrationType" id="calibration" class="form-control custom-select" @change="selectedCalibration">
          <option v-for="item of calibrationTypes" :key="item.id" :value="item.value">
            {{ item.name }}
          </option>
        </select>
        <input
          ref="refEditPrice"
          v-model="modifyPrice"
          type="number"
          min="0"
          max="9999"
          class="form-control custom-price"
          placeholder="price"
          aria-label="price"
        />
        <button class="btn btn-warning custom-focus" type="button" title="cancel price" tabindex="-1" @click="cancelPrice">
          <i class="fas fa-ban"></i>
        </button>
        <button class="btn btn-success custom-focus" type="button" title="save price" tabindex="-1" :disabled="!verifiedPrice()" @click="savePrice">
          <i class="fas fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="col custom-actions">
      <button class="btn btn-primary" type="button" @click="exportPrices">Export</button>
      <button class="btn btn-primary ms-1" type="button" @click="importPrices">Import</button>
    </div>
  </div>
  <div v-if="saveMessage" class="row">
    <div class="col-9">
      <div class="alert alert-warning py-2 ms-2 d-flex justify-content-between align-items-center">
        <span><i class="fas fa-exclamation-triangle me-2"></i>{{ saveMessage }}</span>
        <button type="button" class="btn-close" aria-label="Dismiss" @click="saveMessage = null"></button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-9">
      <ul class="custom-list">
        <li v-for="item in calibrationPricing" :key="item.calibrationPrice">
          <div class="row">
            <div class="col-1">
              <div ref="info-{{item.calibrationPrice}}" class="custom-icon" data-bs-toggle="tooltip" data-bs-placement="top" :title="setInfo(item)">
                <FontAwesomeIcon icon="fas fa-dollar-sign" class="custom-icon-sign" :class="{ 'custom-icon-sign-set': item.firmName !== null }" />
                <FontAwesomeIcon v-if="item.firmName === null" icon="fas fa-slash" class="custom-icon-overlay" />
                <FontAwesomeIcon v-if="parseInt(item.firm) === parseInt(location.firm)" icon="fas fa-check" class="custom-icon-match-overlay" />
              </div>
            </div>
            <div class="col-8">
              <span>{{ item.calibrationTypeName }}</span>
            </div>
            <div class="col-2 text-right">
              <span>${{ formatPrice(item.price) }}</span>
            </div>
            <div class="col-1">
              <a href="#" class="custom-remove" @click="removePrice(item)">
                <i class="fas fa-times text-danger"></i>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="col">
      <span># items: {{ numPrices }}</span>
    </div>
  </div>
  <confirm-delete
    v-model="actionDelete"
    :confirmTitle="confirmTitle"
    :confirmAction="confirmAction"
    :confirmQuestion="confirmQuestion"
    @closing="closeModal"
    @proceed="performDelete"
  />
  <file-dialog
    v-model="actionImport"
    fileTitle="Import Calibration Pricing"
    :fileMessage="fileMessage"
    fileType="csv"
    confirmAction="Import"
    @closing="closeModal"
    @proceed="proceedImport"
  />
  <pricing-upload-dialog
    v-model="actionUpload"
    @download="downloadProblemRows"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { lookupStore } from '@/stores/lookup'
import { locationStore } from '@/stores/location'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import _ from 'lodash'
import moment from 'moment'
import Papa from 'papaparse'
import { Tooltip } from 'bootstrap'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import FileDialog from '@/components/utilities/elements/FileDialog.vue'
import PricingUploadDialog from '@/components/utilities/elements/PricingUploadDialog.vue'
export default {
  name: 'LocationPricing',
  components: {
    FontAwesomeIcon,
    ConfirmDelete,
    FileDialog,
    PricingUploadDialog
  },
  props: {
    firm: Object
  },
  data() {
    return {
      isCalibrationChanged: false,
      systemCalibration: null,
      currentLocation: null,
      confirmTitle: 'Remove Price?',
      confirmAction: 'Remove',
      confirmQuestion: 'Are you sure you wish to Remove (set inactive) this Price?',
      fileMessage: 'Choose a .csv file having the following columns: CalibrationTypeName, VehicleMakeName, Price, IsInactive (the same columns Export produces). Prices below the insurer minimum are saved at the minimum.',
      actionDelete: null,
      actionImport: null,
      actionUpload: null,
      problemCsv: null,
      saveMessage: null,
      isSave: false,
      modifyPrice: null,
      actionPriceItem: null,
      calibrationType: 0,
      currentInsurance: 0,
      vehicleMake: 0
    }
  },
  async mounted() {
    this.isCalibrationChanged = false
    this.resetPrices()
    console.log('Lookups', this.lookups)
    this.vehicleMake = 0
    this.calibrationType = 0
    this.refreshPrices()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, ['lookups']),
    ...mapState(locationStore, ['location', 'calibrationPricing']),
    calibrationTypes() {
      let _types = []
      _types.push({
        id: 0,
        name: 'ALL',
        value: 0
      })
      if (this.lookups['CalibrationType']) {
        this.lookups['CalibrationType'].forEach((item) => {
          _types.push({
            id: item.id,
            name: item.name,
            value: item.id
          })
        })
      }
      console.log('Calibration Types', _types)
      return _types
    },
    vehicleMakes() {
      let _makes = []
      _makes.push({
        id: 0,
        name: 'NONE',
        value: 0
      })
      if (this.lookups['VehicleMake']) {
        this.lookups['VehicleMake'].forEach((item) => {
          _makes.push({
            id: item.id,
            name: item.name,
            value: item.id
          })
        })
      }
      console.log('Vehicle Makes', _makes)
      return _makes
    },
    numPrices() {
      let count = 0
      if (this.calibrationPricing) {
        count = this.calibrationPricing.length
      }
      return count
    }
  },
  methods: {
    ...mapActions(locationStore, ['resetPrices', 'getCalibrationPricing', 'saveCalibrationPricing', 'uploadCalibrationPricing', 'exportCalibrationPricing']),
    closeModal() {
      this.actionDelete = null
      this.actionImport = null
    },
    cancelPrice() {
      this.modifyPrice = null
      this.vehicleMake = 0
      this.calibrationType = 0
      this.currentInsurance = 0
      this.refreshPrices()
    },
    async selectedCalibration() {
      console.log('Selected Calibration', this.calibrationType)
      await this.refreshPrices()
    },
    async selectedMake() {
      console.log('Selected Make', this.vehicleMake)
      await this.refreshPrices()
    },
    formatPrice(value) {
      return value === null ? 0.0 : value.toFixed(2)
    },
    setInfo(data) {
      let info = ''
      if (data.firmName) {
        info = `Price set by ${data.firmName}`
      } else {
        info = 'Price not set'
      }
      // Use Vue's nextTick to ensure the DOM is updated
      this.$nextTick(() => {
        const tooltipElement = this.$refs[`info-${data.calibrationPrice}`]
        if (tooltipElement) {
          new Tooltip(tooltipElement, {
            title: info,
            placement: 'top'
          })
        }
      })

      return info
    },
    async refreshPrices() {
      console.log('Selected Calibration', this.calibrationType)
      if (this.calibrationType !== null && this.calibrationType !== undefined) {
        await this.getCalibrationPricing({
          firm: this.location.firm,
          calibrationType: this.calibrationType,
          vehicleMake: this.vehicleMake === 0 ? null : this.vehicleMake
        })
        console.log('Local provider pricing:', this.calibrationPricing)
      }
    },
    removePrice(item) {
      this.confirmTitle = 'Remove Price?'
      this.confirmAction = 'Remove'
      this.confirmQuestion = 'Are you sure you wish to Remove (set inactive) this Price?'
      this.actionDelete = {
        name: 'Price',
        firm: this.location.firm,
        calibrationPrice: parseInt(item.calibrationPrice),
        price: parseFloat(item.price),
        calibrationType: parseInt(item.calibrationType),
        systemType: null,
        isInactive: true,
        user: this.profile.user,
        ...this.makeFields(item)
      }
    },
    // CalibrationPrice_Get returns vehicleMake as an id on the ALL view but as a name otherwise;
    // the API binds vehicleMake as int, so a name must go in vehicleMakeName
    makeFields(item) {
      if (typeof item.vehicleMake === 'number') {
        return { vehicleMake: item.vehicleMake }
      }
      return { vehicleMakeName: item.vehicleMakeName || item.vehicleMake || null }
    },
    verifiedPrice() {
      let valid = true
      if (typeof this.modifyPrice === 'string' || this.modifyPrice instanceof String) {
        if (this.modifyPrice.trim() === '') {
          valid = false
        }
      }
      if (this.modifyPrice === null) {
        valid = false
      } else if (parseInt(this.modifyPrice) < 0) {
        valid = false
      } else if (parseInt(this.modifyPrice) > 9999) {
        valid = false
      }
      if (this.currentInsurance === null) {
        valid = false
      }
      return valid
    },
    async savePrice() {
      // The insurer minimum is enforced by the API (adasmatrix/saveCalibrationPricing, #684):
      // a price below it is refused with the minimum in the message, shown below.
      let data = {
        firm: this.location.firm,
        price: parseFloat(this.modifyPrice),
        insurance: parseInt(this.currentInsurance),
        calibrationType: parseInt(this.calibrationType),
        systemType: null,
        user: this.profile.user,
        vehicleMake: this.vehicleMake === 0 ? null : this.vehicleMake
      }
      this.saveMessage = null
      try {
        const result = await this.saveCalibrationPricing(data)
        if (result && result.error) {
          this.saveMessage = 'The price could not be saved. Please try again.'
          return
        }
      } catch (error) {
        // the API refuses prices below the insurer minimum, or when the minimum can't be checked
        this.saveMessage = typeof error === 'string' && error ? error : 'The price could not be saved. Please try again.'
        return
      }
      this.modifyPrice = null
      this.calibrationType = 0
      this.currentInsurance = 0
      this.resetPrices()
      await this.refreshPrices()
    },
    async performDelete() {
      console.log('Remove Price', this.actionDelete)
      await this.saveCalibrationPricing(this.actionDelete)
      this.actionDelete = null
      this.modifyPrice = null
      this.calibrationType = 0
      this.currentInsurance = 0
      this.resetPrices()
      await this.refreshPrices()
    },
    async exportPrices() {
      let results = await this.exportCalibrationPricing(this.location.firm)
      if (results) {
        var blob = new Blob([results], { type: 'text/csv' })
        var link = document.createElement('a')
        var now = moment().format('MMDDYYYY')
        var filename = `Calibration Pricing ${now}.csv`
        if (window.URL.createObjectURL) {
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click()
        } else {
          this.message = 'Refresh your browser to generate this download.'
        }
      }
    },
    saveToCsvFile(data, filename) {
      var blob = new Blob([data], { type: 'text/csv' })
      var link = document.createElement('a')
      link.style.display = 'none'
      if (window.URL.createObjectURL) {
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      } else {
        alert('Refresh your browser to generate this download.')
      }
    },
    importPrices() {
      this.calibrationType = 0
      this.actionImport = true
    },
    proceedImport(file) {
      console.log('Import File', file)
      this.actionImport = null
      if (file) {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.processImport(results)
          },
          error: () => {
            this.actionUpload = { state: 'error', message: 'The file could not be read as a CSV.' }
          }
        })
      }
    },
    // header lookup ignoring case/spaces, so Price, price and PRICE all work
    findField(fields, name) {
      return fields.find((f) => f && f.trim().toLowerCase() === name) || null
    },
    async processImport(results) {
      const fields = results.meta?.fields || []
      const records = results.data || []
      const col = {
        calibration: this.findField(fields, 'calibrationtypename'),
        make: this.findField(fields, 'vehiclemakename'),
        price: this.findField(fields, 'price'),
        inactive: this.findField(fields, 'isinactive')
      }
      if (!col.calibration || !col.price) {
        this.actionUpload = { state: 'error', message: 'The file needs CalibrationTypeName and Price columns. Use Export to get a file in the right format.' }
        return
      }
      if (records.length === 0) {
        this.actionUpload = { state: 'error', message: 'The file has no pricing rows.' }
        return
      }
      const cell = (rec, field) => (field && rec[field] !== undefined && rec[field] !== null ? String(rec[field]) : '')
      // row = spreadsheet row number (header is row 1)
      const rows = records.map((rec, i) => ({
        row: i + 2,
        calibrationTypeName: cell(rec, col.calibration),
        vehicleMakeName: cell(rec, col.make),
        price: cell(rec, col.price),
        isInactive: cell(rec, col.inactive)
      }))

      this.actionUpload = { state: 'working', count: rows.length }
      // the server saves row by row; warn before the tab is closed mid-upload
      window.addEventListener('beforeunload', this.warnBeforeUnload)
      try {
        const result = await this.uploadCalibrationPricing({ firm: this.location.firm, user: this.profile.user, rows })
        const saved = result?.saved || []
        const failedResults = result?.failed || []
        const failed = failedResults.map((f) => ({ ...rows[f.row - 2], status: f.status }))
        let fileName = null
        this.problemCsv = null
        if (failed.length > 0) {
          // the original rows, as uploaded, plus a Status column (reused if the file already has one)
          const statusField = this.findField(fields, 'status') || 'Status'
          const columns = fields.filter((f) => f !== statusField).concat(statusField)
          const problemRecords = failedResults.map((f) => ({ ...records[f.row - 2], [statusField]: f.status }))
          fileName = `Calibration Pricing Problems ${moment().format('MMDDYYYY HHmm')}.csv`
          this.problemCsv = { data: Papa.unparse(problemRecords, { columns }), fileName }
          this.downloadProblemRows()
        }
        this.actionUpload = { state: 'done', saved, failed, fileName }
      } catch (error) {
        console.log('Upload Calibration Pricing', error)
        const message = typeof error === 'string' && error ? error : 'The upload failed. Nothing may have been saved; check the list and try again.'
        this.actionUpload = { state: 'error', message }
      } finally {
        window.removeEventListener('beforeunload', this.warnBeforeUnload)
        this.modifyPrice = null
        this.vehicleMake = 0
        this.calibrationType = 0
        this.currentInsurance = 0
        this.resetPrices()
        await this.refreshPrices()
      }
    },
    downloadProblemRows() {
      if (this.problemCsv) {
        this.saveToCsvFile(this.problemCsv.data, this.problemCsv.fileName)
      }
    },
    warnBeforeUnload(event) {
      event.preventDefault()
      event.returnValue = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-actions {
  position: relative;
  text-align: center;
  margin-top: 8px;
}
.custom-list {
  list-style-type: none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 5px;
  padding-left: 20px;
  margin-left: 5px;
  margin-right: 15px;
  height: 500px;
  li {
    border-bottom: 1px solid #eeeeee;
    padding: 5px;
  }
}
.custom-select-vehicle {
  width: 140px !important;
}
.custom-select {
  width: auto;
}
.custom-price {
  width: 80px !important;
  text-align: right;
}
.custom-icon {
  position: relative;
  cursor: pointer;
}
.custom-icon-sign {
  font-size: 0.9rem;
  color: #007bff;
  margin-left: 5px;
}
.custom-icon-sign-set {
  font-size: 1rem;
  color: #0e5700;
  margin-left: 5px;
  font-weight: 600;
}
.custom-icon-overlay {
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 0.9rem;
  color: #dc3545;
}
.custom-icon-match-overlay {
  position: absolute;
  top: 0;
  right: -10px;
  font-size: 0.7rem;
  color: #0e5700;
}
</style>
